import { MapMetadata } from "../types/Map";

export const COUNTRIES: ReadonlyArray<MapMetadata> = [
  {
    alpha2: "AF",
    name: "Afghanistan",
    coordsBoundingBox: [
      60.5284298033, 29.318572496, 75.1580277851, 38.4862816432,
    ],
  },
  {
    alpha2: "AO",
    name: "Angola",
    coordsBoundingBox: [
      11.6400960629, -17.9306364885, 24.0799052263, -4.43802336998,
    ],
  },
  {
    alpha2: "AL",
    name: "Albania",
    coordsBoundingBox: [
      19.3044861183, 39.624997667, 21.0200403175, 42.6882473822,
    ],
  },
  {
    alpha2: "AE",
    name: "United Arab Emirates",
    coordsBoundingBox: [
      51.5795186705, 22.4969475367, 56.3968473651, 26.055464179,
    ],
  },
  {
    alpha2: "AR",
    name: "Argentina",
    coordsBoundingBox: [-73.4154357571, -55.25, -53.628348965, -21.8323104794],
  },
  {
    alpha2: "AM",
    name: "Armenia",
    coordsBoundingBox: [
      43.5827458026, 38.7412014837, 46.5057198423, 41.2481285671,
    ],
  },
  {
    alpha2: "AQ",
    name: "Antarctica",
    coordsBoundingBox: [-180.0, -90.0, 180.0, -63.2706604895],
  },
  {
    alpha2: "TF",
    name: "Fr. S. and Antarctic Lands",
    coordsBoundingBox: [68.72, -49.775, 70.56, -48.625],
  },
  {
    alpha2: "AU",
    name: "Australia",
    coordsBoundingBox: [
      113.338953078, -43.6345972634, 153.569469029, -10.6681857235,
    ],
  },
  {
    alpha2: "AT",
    name: "Austria",
    coordsBoundingBox: [
      9.47996951665, 46.4318173285, 16.9796667823, 49.0390742051,
    ],
  },
  {
    alpha2: "AZ",
    name: "Azerbaijan",
    coordsBoundingBox: [
      44.7939896991, 38.2703775091, 50.3928210793, 41.8606751572,
    ],
  },
  {
    alpha2: "BI",
    name: "Burundi",
    coordsBoundingBox: [
      29.0249263852, -4.49998341229, 30.752262811, -2.34848683025,
    ],
  },
  {
    alpha2: "BE",
    name: "Belgium",
    coordsBoundingBox: [
      2.51357303225, 49.5294835476, 6.15665815596, 51.4750237087,
    ],
  },
  {
    alpha2: "BJ",
    name: "Benin",
    coordsBoundingBox: [
      0.772335646171, 6.14215770103, 3.79711225751, 12.2356358912,
    ],
  },
  {
    alpha2: "BF",
    name: "Burkina Faso",
    coordsBoundingBox: [
      -5.47056494793, 9.61083486576, 2.17710778159, 15.1161577418,
    ],
  },
  {
    alpha2: "BD",
    name: "Bangladesh",
    coordsBoundingBox: [
      88.0844222351, 20.670883287, 92.6727209818, 26.4465255803,
    ],
  },
  {
    alpha2: "BG",
    name: "Bulgaria",
    coordsBoundingBox: [
      22.3805257504, 41.2344859889, 28.5580814959, 44.2349230007,
    ],
  },
  {
    alpha2: "BS",
    name: "Bahamas",
    coordsBoundingBox: [-78.98, 23.71, -77.0, 27.04],
  },
  {
    alpha2: "BA",
    name: "Bosnia and Herz.",
    coordsBoundingBox: [15.7500260759, 42.65, 19.59976, 45.2337767604],
  },
  {
    alpha2: "BY",
    name: "Belarus",
    coordsBoundingBox: [
      23.1994938494, 51.3195034857, 32.6936430193, 56.1691299506,
    ],
  },
  {
    alpha2: "BZ",
    name: "Belize",
    coordsBoundingBox: [
      -89.2291216703, 15.8869375676, -88.1068129138, 18.4999822047,
    ],
  },
  {
    alpha2: "BO",
    name: "Bolivia",
    coordsBoundingBox: [
      -69.5904237535, -22.8729187965, -57.4983711412, -9.76198780685,
    ],
  },
  {
    alpha2: "BR",
    name: "Brazil",
    coordsBoundingBox: [
      -73.9872354804, -33.7683777809, -34.7299934555, 5.24448639569,
    ],
  },
  {
    alpha2: "BN",
    name: "Brunei",
    coordsBoundingBox: [
      114.204016555, 4.007636827, 115.450710484, 5.44772980389,
    ],
  },
  {
    alpha2: "BT",
    name: "Bhutan",
    coordsBoundingBox: [
      88.8142484883, 26.7194029811, 92.1037117859, 28.2964385035,
    ],
  },
  {
    alpha2: "BW",
    name: "Botswana",
    coordsBoundingBox: [
      19.8954577979, -26.8285429827, 29.4321883481, -17.6618156877,
    ],
  },
  {
    alpha2: "CF",
    name: "Central African Rep.",
    coordsBoundingBox: [
      14.4594071794, 2.2676396753, 27.3742261085, 11.1423951278,
    ],
  },
  {
    alpha2: "CA",
    name: "Canada",
    coordsBoundingBox: [-140.99778, 41.6751050889, -52.6480987209, 83.23324],
  },
  {
    alpha2: "CH",
    name: "Switzerland",
    coordsBoundingBox: [
      6.02260949059, 45.7769477403, 10.4427014502, 47.8308275417,
    ],
  },
  {
    alpha2: "CL",
    name: "Chile",
    coordsBoundingBox: [-75.6443953112, -55.61183, -66.95992, -17.5800118954],
  },
  {
    alpha2: "CN",
    name: "China",
    coordsBoundingBox: [
      73.6753792663, 18.197700914, 135.026311477, 53.4588044297,
    ],
  },
  {
    alpha2: "CI",
    name: "Ivory Coast",
    coordsBoundingBox: [
      -8.60288021487, 4.33828847902, -2.56218950033, 10.5240607772,
    ],
  },
  {
    alpha2: "CM",
    name: "Cameroon",
    coordsBoundingBox: [
      8.48881554529, 1.72767263428, 16.0128524106, 12.8593962671,
    ],
  },
  {
    alpha2: "CD",
    name: "Congo Kinshasa",
    coordsBoundingBox: [
      12.1823368669, -13.2572266578, 31.1741492042, 5.25608775474,
    ],
  },
  {
    alpha2: "CG",
    name: "Congo Brazzaville",
    coordsBoundingBox: [
      11.0937728207, -5.03798674888, 18.4530652198, 3.72819651938,
    ],
  },
  {
    alpha2: "CO",
    name: "Colombia",
    coordsBoundingBox: [
      -78.9909352282, -4.29818694419, -66.8763258531, 12.4373031682,
    ],
  },
  {
    alpha2: "CR",
    name: "Costa Rica",
    coordsBoundingBox: [
      -85.94172543, 8.22502798099, -82.5461962552, 11.2171192489,
    ],
  },
  {
    alpha2: "CU",
    name: "Cuba",
    coordsBoundingBox: [
      -84.9749110583, 19.8554808619, -74.1780248685, 23.1886107447,
    ],
  },
  {
    alpha2: "CY",
    name: "Cyprus",
    coordsBoundingBox: [
      32.2566671079, 34.5718694118, 34.0048808123, 35.1731247015,
    ],
  },
  {
    alpha2: "CZ",
    name: "Czech Rep.",
    coordsBoundingBox: [
      12.2401111182, 48.5553052842, 18.8531441586, 51.1172677679,
    ],
  },
  {
    alpha2: "DE",
    name: "Germany",
    coordsBoundingBox: [
      5.98865807458, 47.3024876979, 15.0169958839, 54.983104153,
    ],
  },
  {
    alpha2: "DJ",
    name: "Djibouti",
    coordsBoundingBox: [41.66176, 10.9268785669, 43.3178524107, 12.6996385767],
  },
  {
    alpha2: "DK",
    name: "Denmark",
    coordsBoundingBox: [
      8.08997684086, 54.8000145534, 12.6900061378, 57.730016588,
    ],
  },
  {
    alpha2: "DO",
    name: "Dominican Rep.",
    coordsBoundingBox: [
      -71.9451120673, 17.598564358, -68.3179432848, 19.8849105901,
    ],
  },
  {
    alpha2: "DZ",
    name: "Algeria",
    coordsBoundingBox: [
      -8.68439978681, 19.0573642034, 11.9995056495, 37.1183806422,
    ],
  },
  {
    alpha2: "EC",
    name: "Ecuador",
    coordsBoundingBox: [
      -80.9677654691, -4.95912851321, -75.2337227037, 1.3809237736,
    ],
  },
  {
    alpha2: "EG",
    name: "Egypt",
    coordsBoundingBox: [24.70007, 22.0, 36.86623, 31.58568],
  },
  {
    alpha2: "ER",
    name: "Eritrea",
    coordsBoundingBox: [
      36.3231889178, 12.4554157577, 43.0812260272, 17.9983074,
    ],
  },
  {
    alpha2: "ES",
    name: "Spain",
    coordsBoundingBox: [
      -9.39288367353, 35.946850084, 3.03948408368, 43.7483377142,
    ],
  },
  {
    alpha2: "EE",
    name: "Estonia",
    coordsBoundingBox: [
      23.3397953631, 57.4745283067, 28.1316992531, 59.6110903998,
    ],
  },
  {
    alpha2: "ET",
    name: "Ethiopia",
    coordsBoundingBox: [32.95418, 3.42206, 47.78942, 14.95943],
  },
  {
    alpha2: "FI",
    name: "Finland",
    coordsBoundingBox: [
      20.6455928891, 59.846373196, 31.5160921567, 70.1641930203,
    ],
  },
  {
    alpha2: "FJ",
    name: "Fiji",
    coordsBoundingBox: [-180.0, -18.28799, 180.0, -16.0208822567],
  },
  {
    alpha2: "FK",
    name: "Falkland Is.",
    coordsBoundingBox: [-61.2, -52.3, -57.75, -51.1],
  },
  {
    alpha2: "FR",
    name: "France",
    coordsBoundingBox: [
      -54.5247541978, 2.05338918702, 9.56001631027, 51.1485061713,
    ],
  },
  {
    alpha2: "GA",
    name: "Gabon",
    coordsBoundingBox: [
      8.79799563969, -3.97882659263, 14.4254557634, 2.32675751384,
    ],
  },
  {
    alpha2: "GB",
    name: "United Kingdom",
    coordsBoundingBox: [
      -7.57216793459, 49.959999905, 1.68153079591, 58.6350001085,
    ],
  },
  {
    alpha2: "GE",
    name: "Georgia",
    coordsBoundingBox: [
      39.9550085793, 41.0644446885, 46.6379081561, 43.553104153,
    ],
  },
  {
    alpha2: "GH",
    name: "Ghana",
    coordsBoundingBox: [
      -3.24437008301, 4.71046214438, 1.0601216976, 11.0983409693,
    ],
  },
  {
    alpha2: "GN",
    name: "Guinea",
    coordsBoundingBox: [
      -15.1303112452, 7.3090373804, -7.83210038902, 12.5861829696,
    ],
  },
  {
    alpha2: "GM",
    name: "Gambia",
    coordsBoundingBox: [
      -16.8415246241, 13.1302841252, -13.8449633448, 13.8764918075,
    ],
  },
  {
    alpha2: "GW",
    name: "Guinea Bissau",
    coordsBoundingBox: [
      -16.6774519516, 11.0404116887, -13.7004760401, 12.6281700708,
    ],
  },
  {
    alpha2: "GQ",
    name: "Eq. Guinea",
    coordsBoundingBox: [
      9.3056132341, 1.01011953369, 11.285078973, 2.28386607504,
    ],
  },
  {
    alpha2: "GR",
    name: "Greece",
    coordsBoundingBox: [
      20.1500159034, 34.9199876979, 26.6041955909, 41.8269046087,
    ],
  },
  {
    alpha2: "GL",
    name: "Greenland",
    coordsBoundingBox: [-73.297, 60.03676, -12.20855, 83.64513],
  },
  {
    alpha2: "GT",
    name: "Guatemala",
    coordsBoundingBox: [
      -92.2292486234, 13.7353376327, -88.2250227526, 17.8193260767,
    ],
  },
  {
    alpha2: "GY",
    name: "Guyana",
    coordsBoundingBox: [
      -61.4103029039, 1.26808828369, -56.5393857489, 8.36703481692,
    ],
  },
  {
    alpha2: "HN",
    name: "Honduras",
    coordsBoundingBox: [
      -89.3533259753, 12.9846857772, -83.147219001, 16.0054057886,
    ],
  },
  {
    alpha2: "HR",
    name: "Croatia",
    coordsBoundingBox: [
      13.6569755388, 42.47999136, 19.3904757016, 46.5037509222,
    ],
  },
  {
    alpha2: "HT",
    name: "Haiti",
    coordsBoundingBox: [
      -74.4580336168, 18.0309927434, -71.6248732164, 19.9156839055,
    ],
  },
  {
    alpha2: "HU",
    name: "Hungary",
    coordsBoundingBox: [
      16.2022982113, 45.7594811061, 22.710531447, 48.6238540716,
    ],
  },
  {
    alpha2: "ID",
    name: "Indonesia",
    coordsBoundingBox: [
      95.2930261576, -10.3599874813, 141.03385176, 5.47982086834,
    ],
  },
  {
    alpha2: "IN",
    name: "India",
    coordsBoundingBox: [
      68.1766451354, 7.96553477623, 97.4025614766, 35.4940095078,
    ],
  },
  {
    alpha2: "IE",
    name: "Ireland",
    coordsBoundingBox: [
      -9.97708574059, 51.6693012559, -6.03298539878, 55.1316222195,
    ],
  },
  {
    alpha2: "IR",
    name: "Iran",
    coordsBoundingBox: [
      44.1092252948, 25.0782370061, 63.3166317076, 39.7130026312,
    ],
  },
  {
    alpha2: "IQ",
    name: "Iraq",
    coordsBoundingBox: [
      38.7923405291, 29.0990251735, 48.5679712258, 37.3852635768,
    ],
  },
  {
    alpha2: "IS",
    name: "Iceland",
    coordsBoundingBox: [
      -24.3261840479, 63.4963829617, -13.609732225, 66.5267923041,
    ],
  },
  {
    alpha2: "IL",
    name: "Israel",
    coordsBoundingBox: [
      34.2654333839, 29.5013261988, 35.8363969256, 33.2774264593,
    ],
  },
  {
    alpha2: "IT",
    name: "Italy",
    coordsBoundingBox: [
      6.7499552751, 36.619987291, 18.4802470232, 47.1153931748,
    ],
  },
  {
    alpha2: "JM",
    name: "Jamaica",
    coordsBoundingBox: [
      -78.3377192858, 17.7011162379, -76.1996585761, 18.5242184514,
    ],
  },
  {
    alpha2: "JO",
    name: "Jordan",
    coordsBoundingBox: [
      34.9226025734, 29.1974946152, 39.1954683774, 33.3786864284,
    ],
  },
  {
    alpha2: "JP",
    name: "Japan",
    coordsBoundingBox: [
      129.408463169, 31.0295791692, 145.543137242, 45.5514834662,
    ],
  },
  {
    alpha2: "KZ",
    name: "Kazakhstan",
    coordsBoundingBox: [
      46.4664457538, 40.6623245306, 87.3599703308, 55.3852501491,
    ],
  },
  {
    alpha2: "KE",
    name: "Kenya",
    coordsBoundingBox: [33.8935689697, -4.67677, 41.8550830926, 5.506],
  },
  {
    alpha2: "KG",
    name: "Kyrgyzstan",
    coordsBoundingBox: [
      69.464886916, 39.2794632025, 80.2599902689, 43.2983393418,
    ],
  },
  {
    alpha2: "KH",
    name: "Cambodia",
    coordsBoundingBox: [
      102.3480994, 10.4865436874, 107.614547968, 14.5705838078,
    ],
  },
  {
    alpha2: "KR",
    name: "S. Korea",
    coordsBoundingBox: [
      126.117397903, 34.3900458847, 129.468304478, 38.6122429469,
    ],
  },
  {
    alpha2: "KW",
    name: "Kuwait",
    coordsBoundingBox: [
      46.5687134133, 28.5260627304, 48.4160941913, 30.0590699326,
    ],
  },
  {
    alpha2: "LA",
    name: "Laos",
    coordsBoundingBox: [
      100.115987583, 13.88109101, 107.564525181, 22.4647531194,
    ],
  },
  {
    alpha2: "LB",
    name: "Lebanon",
    coordsBoundingBox: [
      35.1260526873, 33.0890400254, 36.6117501157, 34.6449140488,
    ],
  },
  {
    alpha2: "LR",
    name: "Liberia",
    coordsBoundingBox: [
      -11.4387794662, 4.35575511313, -7.53971513511, 8.54105520267,
    ],
  },
  {
    alpha2: "LY",
    name: "Libya",
    coordsBoundingBox: [9.31941084152, 19.58047, 25.16482, 33.1369957545],
  },
  {
    alpha2: "LK",
    name: "Sri Lanka",
    coordsBoundingBox: [
      79.6951668639, 5.96836985923, 81.7879590189, 9.82407766361,
    ],
  },
  {
    alpha2: "LS",
    name: "Lesotho",
    coordsBoundingBox: [
      26.9992619158, -30.6451058896, 29.3251664568, -28.6475017229,
    ],
  },
  {
    alpha2: "LT",
    name: "Lithuania",
    coordsBoundingBox: [
      21.0558004086, 53.9057022162, 26.5882792498, 56.3725283881,
    ],
  },
  {
    alpha2: "LU",
    name: "Luxembourg",
    coordsBoundingBox: [
      5.67405195478, 49.4426671413, 6.24275109216, 50.1280516628,
    ],
  },
  {
    alpha2: "LV",
    name: "Latvia",
    coordsBoundingBox: [
      21.0558004086, 55.61510692, 28.1767094256, 57.9701569688,
    ],
  },
  {
    alpha2: "MA",
    name: "Morocco",
    coordsBoundingBox: [
      -17.0204284327, 21.4207341578, -1.12455115397, 35.7599881048,
    ],
  },
  {
    alpha2: "MD",
    name: "Moldova",
    coordsBoundingBox: [
      26.6193367856, 45.4882831895, 30.0246586443, 48.4671194525,
    ],
  },
  {
    alpha2: "MG",
    name: "Madagascar",
    coordsBoundingBox: [
      43.2541870461, -25.6014344215, 50.4765368996, -12.0405567359,
    ],
  },
  {
    alpha2: "MX",
    name: "Mexico",
    coordsBoundingBox: [-117.12776, 14.5388286402, -86.811982388, 32.72083],
  },
  {
    alpha2: "MK",
    name: "Macedonia",
    coordsBoundingBox: [20.46315, 40.8427269557, 22.9523771502, 42.3202595078],
  },
  {
    alpha2: "ML",
    name: "Mali",
    coordsBoundingBox: [
      -12.1707502914, 10.0963607854, 4.27020999514, 24.9745740829,
    ],
  },
  {
    alpha2: "MM",
    name: "Myanmar",
    coordsBoundingBox: [
      92.3032344909, 9.93295990645, 101.180005324, 28.335945136,
    ],
  },
  {
    alpha2: "ME",
    name: "Montenegro",
    coordsBoundingBox: [18.45, 41.87755, 20.3398, 43.52384],
  },
  {
    alpha2: "MN",
    name: "Mongolia",
    coordsBoundingBox: [
      87.7512642761, 41.5974095729, 119.772823928, 52.0473660345,
    ],
  },
  {
    alpha2: "MZ",
    name: "Mozambique",
    coordsBoundingBox: [
      30.1794812355, -26.7421916643, 40.7754752948, -10.3170960425,
    ],
  },
  {
    alpha2: "MR",
    name: "Mauritania",
    coordsBoundingBox: [
      -17.0634232243, 14.6168342147, -4.92333736817, 27.3957441269,
    ],
  },
  {
    alpha2: "MW",
    name: "Malawi",
    coordsBoundingBox: [
      32.6881653175, -16.8012997372, 35.7719047381, -9.23059905359,
    ],
  },
  {
    alpha2: "MY",
    name: "Malaysia",
    coordsBoundingBox: [
      100.085756871, 0.773131415201, 119.181903925, 6.92805288332,
    ],
  },
  {
    alpha2: "NA",
    name: "Namibia",
    coordsBoundingBox: [
      11.7341988461, -29.045461928, 25.0844433937, -16.9413428687,
    ],
  },
  {
    alpha2: "NC",
    name: "New Caledonia",
    coordsBoundingBox: [
      164.029605748, -22.3999760881, 167.120011428, -20.1056458473,
    ],
  },
  {
    alpha2: "NE",
    name: "Niger",
    coordsBoundingBox: [
      0.295646396495, 11.6601671412, 15.9032466977, 23.4716684026,
    ],
  },
  {
    alpha2: "NG",
    name: "Nigeria",
    coordsBoundingBox: [
      2.69170169436, 4.24059418377, 14.5771777686, 13.8659239771,
    ],
  },
  {
    alpha2: "NI",
    name: "Nicaragua",
    coordsBoundingBox: [
      -87.6684934151, 10.7268390975, -83.147219001, 15.0162671981,
    ],
  },
  {
    alpha2: "NL",
    name: "Netherlands",
    coordsBoundingBox: [
      3.31497114423, 50.803721015, 7.09205325687, 53.5104033474,
    ],
  },
  {
    alpha2: "NO",
    name: "Norway",
    coordsBoundingBox: [
      4.99207807783, 58.0788841824, 31.29341841, 80.6571442736,
    ],
  },
  {
    alpha2: "NP",
    name: "Nepal",
    coordsBoundingBox: [
      80.0884245137, 26.3978980576, 88.1748043151, 30.4227169866,
    ],
  },
  {
    alpha2: "NZ",
    name: "New Zealand",
    coordsBoundingBox: [
      166.509144322, -46.641235447, 178.517093541, -34.4506617165,
    ],
  },
  {
    alpha2: "OM",
    name: "Oman",
    coordsBoundingBox: [
      52.0000098, 16.6510511337, 59.8080603372, 26.3959343531,
    ],
  },
  {
    alpha2: "PK",
    name: "Pakistan",
    coordsBoundingBox: [
      60.8742484882, 23.6919650335, 77.8374507995, 37.1330309108,
    ],
  },
  {
    alpha2: "PA",
    name: "Panama",
    coordsBoundingBox: [
      -82.9657830472, 7.2205414901, -77.2425664944, 9.61161001224,
    ],
  },
  {
    alpha2: "PE",
    name: "Peru",
    coordsBoundingBox: [
      -81.4109425524, -18.3479753557, -68.6650797187, -0.0572054988649,
    ],
  },
  {
    alpha2: "PH",
    name: "Philippines",
    coordsBoundingBox: [
      117.17427453, 5.58100332277, 126.537423944, 18.5052273625,
    ],
  },
  {
    alpha2: "PG",
    name: "Papua New Guinea",
    coordsBoundingBox: [
      141.000210403, -10.6524760881, 156.019965448, -2.50000212973,
    ],
  },
  {
    alpha2: "PL",
    name: "Poland",
    coordsBoundingBox: [
      14.0745211117, 49.0273953314, 24.0299857927, 54.8515359564,
    ],
  },
  {
    alpha2: "PR",
    name: "Puerto Rico",
    coordsBoundingBox: [
      -67.2424275377, 17.946553453, -65.5910037909, 18.5206011011,
    ],
  },
  {
    alpha2: "KP",
    name: "N. Korea",
    coordsBoundingBox: [
      124.265624628, 37.669070543, 130.780007359, 42.9853868678,
    ],
  },
  {
    alpha2: "PT",
    name: "Portugal",
    coordsBoundingBox: [
      -9.52657060387, 36.838268541, -6.3890876937, 42.280468655,
    ],
  },
  {
    alpha2: "PY",
    name: "Paraguay",
    coordsBoundingBox: [
      -62.6850571357, -27.5484990374, -54.2929595608, -19.3427466773,
    ],
  },
  {
    alpha2: "QA",
    name: "Qatar",
    coordsBoundingBox: [
      50.7439107603, 24.5563308782, 51.6067004738, 26.1145820175,
    ],
  },
  {
    alpha2: "RO",
    name: "Romania",
    coordsBoundingBox: [
      20.2201924985, 43.6884447292, 29.62654341, 48.2208812526,
    ],
  },
  {
    alpha2: "RU",
    name: "Russia",
    coordsBoundingBox: [-180.0, 41.151416124, 180.0, 81.2504],
  },
  {
    alpha2: "RW",
    name: "Rwanda",
    coordsBoundingBox: [
      29.0249263852, -2.91785776125, 30.8161348813, -1.13465911215,
    ],
  },
  {
    alpha2: "SA",
    name: "Saudi Arabia",
    coordsBoundingBox: [
      34.6323360532, 16.3478913436, 55.6666593769, 32.161008816,
    ],
  },
  {
    alpha2: "SD",
    name: "Sudan",
    coordsBoundingBox: [21.93681, 8.61972971293, 38.4100899595, 22.0],
  },
  {
    alpha2: "SS",
    name: "S. Sudan",
    coordsBoundingBox: [23.8869795809, 3.50917, 35.2980071182, 12.2480077571],
  },
  {
    alpha2: "SN",
    name: "Senegal",
    coordsBoundingBox: [
      -17.6250426905, 12.332089952, -11.4678991358, 16.5982636581,
    ],
  },
  {
    alpha2: "SB",
    name: "Solomon Is.",
    coordsBoundingBox: [
      156.491357864, -10.8263672828, 162.398645868, -6.59933847415,
    ],
  },
  {
    alpha2: "SL",
    name: "Sierra Leone",
    coordsBoundingBox: [
      -13.2465502588, 6.78591685631, -10.2300935531, 10.0469839543,
    ],
  },
  {
    alpha2: "SV",
    name: "El Salvador",
    coordsBoundingBox: [
      -90.0955545723, 13.1490168319, -87.7235029772, 14.4241327987,
    ],
  },
  {
    alpha2: "SO",
    name: "Somalia",
    coordsBoundingBox: [40.98105, -1.68325, 51.13387, 12.02464],
  },
  {
    alpha2: "RS",
    name: "Serbia",
    coordsBoundingBox: [18.82982, 42.2452243971, 22.9860185076, 46.1717298447],
  },
  {
    alpha2: "SR",
    name: "Suriname",
    coordsBoundingBox: [
      -58.0446943834, 1.81766714112, -53.9580446031, 6.0252914494,
    ],
  },
  {
    alpha2: "SK",
    name: "Slovakia",
    coordsBoundingBox: [
      16.8799829444, 47.7584288601, 22.5581376482, 49.5715740017,
    ],
  },
  {
    alpha2: "SI",
    name: "Slovenia",
    coordsBoundingBox: [
      13.6981099789, 45.4523163926, 16.5648083839, 46.8523859727,
    ],
  },
  {
    alpha2: "SE",
    name: "Sweden",
    coordsBoundingBox: [
      11.0273686052, 55.3617373725, 23.9033785336, 69.1062472602,
    ],
  },
  {
    alpha2: "SZ",
    name: "Swaziland",
    coordsBoundingBox: [
      30.6766085141, -27.2858794085, 32.0716654803, -25.660190525,
    ],
  },
  {
    alpha2: "SY",
    name: "Syria",
    coordsBoundingBox: [
      35.7007979673, 32.312937527, 42.3495910988, 37.2298725449,
    ],
  },
  {
    alpha2: "TD",
    name: "Chad",
    coordsBoundingBox: [13.5403935076, 7.42192454674, 23.88689, 23.40972],
  },
  {
    alpha2: "TG",
    name: "Togo",
    coordsBoundingBox: [
      -0.0497847151599, 5.92883738853, 1.86524051271, 11.0186817489,
    ],
  },
  {
    alpha2: "TH",
    name: "Thailand",
    coordsBoundingBox: [
      97.3758964376, 5.69138418215, 105.589038527, 20.4178496363,
    ],
  },
  {
    alpha2: "TJ",
    name: "Tajikistan",
    coordsBoundingBox: [
      67.4422196796, 36.7381712916, 74.9800024759, 40.9602133245,
    ],
  },
  {
    alpha2: "TM",
    name: "Turkmenistan",
    coordsBoundingBox: [
      52.5024597512, 35.2706639674, 66.5461503437, 42.7515510117,
    ],
  },
  {
    alpha2: "TL",
    name: "East Timor",
    coordsBoundingBox: [
      124.968682489, -9.39317310958, 127.335928176, -8.27334482181,
    ],
  },
  {
    alpha2: "TT",
    name: "Trinidad and Tobago",
    coordsBoundingBox: [-61.95, 10.0, -60.895, 10.89],
  },
  {
    alpha2: "TN",
    name: "Tunisia",
    coordsBoundingBox: [
      7.52448164229, 30.3075560572, 11.4887874691, 37.3499944118,
    ],
  },
  {
    alpha2: "TR",
    name: "Turkey",
    coordsBoundingBox: [
      26.0433512713, 35.8215347357, 44.7939896991, 42.1414848903,
    ],
  },
  {
    alpha2: "TW",
    name: "Taiwan",
    coordsBoundingBox: [
      120.106188593, 21.9705713974, 121.951243931, 25.2954588893,
    ],
  },
  {
    alpha2: "TZ",
    name: "Tanzania",
    coordsBoundingBox: [29.3399975929, -11.7209380022, 40.31659, -0.95],
  },
  {
    alpha2: "UG",
    name: "Uganda",
    coordsBoundingBox: [29.5794661801, -1.44332244223, 35.03599, 4.24988494736],
  },
  {
    alpha2: "UA",
    name: "Ukraine",
    coordsBoundingBox: [
      22.0856083513, 44.3614785833, 40.0807890155, 52.3350745713,
    ],
  },
  {
    alpha2: "UY",
    name: "Uruguay",
    coordsBoundingBox: [
      -58.4270741441, -34.9526465797, -53.209588996, -30.1096863746,
    ],
  },
  {
    alpha2: "US",
    name: "United States",
    coordsBoundingBox: [-171.791110603, 18.91619, -66.96466, 71.3577635769],
  },
  {
    alpha2: "UZ",
    name: "Uzbekistan",
    coordsBoundingBox: [
      55.9289172707, 37.1449940049, 73.055417108, 45.5868043076,
    ],
  },
  {
    alpha2: "VE",
    name: "Venezuela",
    coordsBoundingBox: [
      -73.3049515449, 0.724452215982, -59.7582848782, 12.1623070337,
    ],
  },
  {
    alpha2: "VN",
    name: "Vietnam",
    coordsBoundingBox: [
      102.170435826, 8.59975962975, 109.33526981, 23.3520633001,
    ],
  },
  {
    alpha2: "VU",
    name: "Vanuatu",
    coordsBoundingBox: [
      166.629136998, -16.5978496233, 167.844876744, -14.6264970842,
    ],
  },
  {
    alpha2: "PS",
    name: "West Bank",
    coordsBoundingBox: [
      34.9274084816, 31.3534353704, 35.5456653175, 32.5325106878,
    ],
  },
  {
    alpha2: "YE",
    name: "Yemen",
    coordsBoundingBox: [
      42.6048726743, 12.5859504257, 53.1085726255, 19.0000033635,
    ],
  },
  {
    alpha2: "ZA",
    name: "South Africa",
    coordsBoundingBox: [
      16.3449768409, -34.8191663551, 32.830120477, -22.0913127581,
    ],
  },
  {
    alpha2: "ZM",
    name: "Zambia",
    coordsBoundingBox: [
      21.887842645, -17.9612289364, 33.4856876971, -8.23825652429,
    ],
  },
  {
    alpha2: "ZW",
    name: "Zimbabwe",
    coordsBoundingBox: [
      25.2642257016, -22.2716118303, 32.8498608742, -15.5077869605,
    ],
  },
];
